
import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Target, Activity, Handshake, BarChart, Lightbulb } from 'lucide-react';
import { AnalysisResult } from './types';
import FocusAreasTab from './tabs/FocusAreasTab';
import SalesActivitiesTab from './tabs/SalesActivitiesTab';
import ExecutionApproachTab from './tabs/ExecutionApproachTab';
import OpportunitiesTab from './tabs/OpportunitiesTab';
import RiskMitigationTab from './tabs/RiskMitigationTab';

type AnalysisTabsProps = {
  analysisResult: AnalysisResult;
  activeTab: string;
  onTabChange: (value: string) => void;
};

const AnalysisTabs = ({ analysisResult, activeTab, onTabChange }: AnalysisTabsProps) => {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="w-full grid grid-cols-5 bg-secondary/50 border border-primary/20">
        <TabsTrigger 
          value="focus" 
          className="flex items-center gap-2 text-white data-[state=active]:bg-white data-[state=active]:text-black"
        >
          <Target className="h-4 w-4" />
          <span>Focus Areas</span>
        </TabsTrigger>
        <TabsTrigger 
          value="activities" 
          className="flex items-center gap-2 text-white data-[state=active]:bg-white data-[state=active]:text-black"
        >
          <Activity className="h-4 w-4" />
          <span>Sales Activities</span>
        </TabsTrigger>
        <TabsTrigger 
          value="approach" 
          className="flex items-center gap-2 text-white data-[state=active]:bg-white data-[state=active]:text-black"
        >
          <Handshake className="h-4 w-4" />
          <span>Execution Strategy</span>
        </TabsTrigger>
        <TabsTrigger 
          value="opportunities" 
          className="flex items-center gap-2 text-white data-[state=active]:bg-white data-[state=active]:text-black"
        >
          <BarChart className="h-4 w-4" />
          <span>Revenue Opportunities</span>
        </TabsTrigger>
        <TabsTrigger 
          value="risks" 
          className="flex items-center gap-2 text-white data-[state=active]:bg-white data-[state=active]:text-black"
        >
          <Lightbulb className="h-4 w-4" />
          <span>Risk Mitigation</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="focus" className="mt-4">
        <FocusAreasTab analysisResult={analysisResult} />
      </TabsContent>
      
      <TabsContent value="activities" className="mt-4">
        <SalesActivitiesTab analysisResult={analysisResult} />
      </TabsContent>
      
      <TabsContent value="approach" className="mt-4">
        <ExecutionApproachTab analysisResult={analysisResult} />
      </TabsContent>
      
      <TabsContent value="opportunities" className="mt-4">
        <OpportunitiesTab analysisResult={analysisResult} />
      </TabsContent>
      
      <TabsContent value="risks" className="mt-4">
        <RiskMitigationTab analysisResult={analysisResult} />
      </TabsContent>
    </Tabs>
  );
};

export default AnalysisTabs;
